const errorsMapping = {
  SOMETHING_WENT_WRONG: "errors.somethingWentWrong"
};
export {
  errorsMapping
};
//# sourceMappingURL=errors-mapping.js.map
